<!-- ================管理端-创建编辑读书会====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{!eventId?'创建读书会':'编辑读书会'}}</div>
        </div>
        <div class="create-content-container">
                <el-form style="padding-bottom: 15px;" ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-row>
                        <el-col :span="15">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="活动主题" prop="eventTheme">
                                        <el-input v-model="form.eventTheme" placeholder="请输入活动主题"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="学段" prop="periodKey">
                                        <el-select @change="changePeriodForm"  v-model="form.periodKey" placeholder="请选择">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="年级" prop="gradeKey">
                                        <el-select v-model="form.gradeKey" placeholder="请选择">
                                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="年级段" prop="eventGrade">
                                        <el-select  v-model="form.eventGrade" placeholder="请选择">
                                            <el-option v-for="item in eventGradeList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="所属五馆" prop="museumKey">
                                        <el-select disabled v-model="form.museumKey" placeholder="请选择所属馆">
                                            <el-option v-for="item in museumList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="所属主题" prop="eventItem">
                                        <el-select v-model="form.eventItem" placeholder="请选择主题">
                                            <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                                       :value="item.itemId" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="活动时长" prop="eventTime">
                                        <el-input v-model="form.eventTime" placeholder="请输入活动时长"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="8">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="活动封面" prop="eventCover" label-position="top" >
                                        <el-upload class="event-avatar-uploader"
                                                   :action="serviceUrl+'/businessservice/book/uploadCover'" :show-file-list="false"
                                                   accept=".jpg,.png,.jpeg"
                                                   :on-success="handleAvatarSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                            <img alt="" v-if="form.eventCover" :src="form.eventCover" class="avatar" style="position:absolute" />
                                            <el-icon class="event-avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                                <Plus />
                                            </el-icon>
                                        </el-upload>
                                        <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="核心读物" prop="eventBook">
                                <div class="" style="width: 100%;">
                                    <div style="width: 100%;margin-top: -1px">
                                        <el-link @click="selectBook" type="primary" :underline="false">+选择核心读物</el-link>
                                    </div>
                                    <div class="v-list-container" v-if="bookList&&bookList.length>0">
                                        <div class="v-list-item" v-for="(item,index) in bookList" :key="index">
                                            <div class="video-cover">
                                                <img alt="" :src="item.bookCover" class="img-100">
                                            </div>
                                            <div class="v-t">
                                                <div class="v-t-l">{{item.bookName}}</div>
                                                <div class="v-t-r">
                                                    <img alt="" @click="handleListDelBook(item)" class="img-100" src="../../../assets/image/icon-del.png">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="活动准备" prop="eventPrepare">
                                <el-input type="textarea" rows="5" v-model="form.eventPrepare" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="活动流程" prop="eventFlow">
                                <el-input type="textarea" rows="5" v-model="form.eventFlow" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>
    </div>

    <el-dialog class="ve-dialog" :title="'选择核心读物'" v-model="isShowBook" top="4vh" width="835px">
        <div class="sel-video-contain">
            <!--目录-->
            <div class="r-container">
                <div class="form-box">
                    <el-row style="height: 40px!important;">
                        <el-col :span="6" class="mb0">
                            <el-form-item label="主题" prop="myjrItem">
                                <el-select clearable @change="handleQueryBook" v-model="queryParams.bookItem" placeholder="请选择">
                                    <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                               :value="item.itemId" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="handleQueryBook" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.bookName" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button @click="handleQueryBook" type="primary" icon="el-icon-search" style="background-color: #377f7f;color: #fff" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-scrollbar class="vl-container">
                    <div class="video-box">
                        <div class="video-item" v-for="item in allBookList">
                            <div class="item-p1">
                                <div class="video-cover">
                                    <img alt="" :src="item.bookCover" class="img-100">
                                </div>
                                <div :class="selVId&&selVId.includes(item.bookId)?'video-name-c':'video-name'"  @click="addOrCancelBook(item)">
                                    <svg  v-if="selVId&&selVId.includes(item.bookId)" t="1782110481295" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1506" width="20" height="20"><path d="M192 128h640a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H192a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m250.752 467.712L299.136 464.704 212.864 559.36l240.384 219.264 363.008-416.512-96.512-84.096-276.992 317.76z" fill="#377f7f" p-id="1507"></path></svg>
                                    <svg v-if="!(selVId&&selVId.includes(item.bookId))"  t="1782110481295" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1506" width="20" height="20"><path d="M192 128h640a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H192a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m250.752 467.712L299.136 464.704 212.864 559.36l240.384 219.264 363.008-416.512-96.512-84.096-276.992 317.76z" fill="#cdcdcd" p-id="1507"></path></svg>
                                    {{item.bookName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <div class="sel-info-contain">
            <div class="info-item1">已选中<span style="color: #377f7f;font-weight: bold">{{bookNum}}</span>本书籍</div>
            <div class="info-item2"> <el-button @click="isShowBook = !isShowBook">取 消</el-button></div>
            <div class="info-item3"><el-button type="primary" @click="isShowBook = !isShowBook">确 认</el-button></div>
        </div>
    </el-dialog>
</template>
<script>
import {ElLoading} from "element-plus";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/dict";
import {createEvent,updateEvent,infoEvent} from "@/api/admin/event"
import {listItem} from "@/api/admin/item";
import {listBook} from "@/api/admin/book";

export default {
    components: {},
    name: "bookCreate",
    data() {
        return {
            isShowBook:false,
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            eventId:'',
            periodList:[],
            gradeList:[],
            queryItemParams:{
                itemType:1,
                museumKey:'1',
            },
            itemList:[],
            eventGradeList:[],
            museumList:[],
            // 表单参数
            form: {
                eventId:'',
                eventCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
                eventTheme:'',
                eventItem:'',
                periodKey:'',
                gradeKey:'',
                eventBook:'',
                eventTime:'',
                eventPrepare:'',
                eventFlow:'',
                eventGrade:'',
                museumKey:'1',
            },
            rules:{
                eventTheme: [{ required: true, message: "请输入活动主题", trigger: "blur" },],
                eventCover: [{ required: true, validator: this.checkCoverValidator  },],
                eventItem: [{ required: true, message: "请选择所属主题", trigger: "change" },],
                museumKey: [{ required: true, message: "请选择五馆", trigger: "change" },],
                periodKey: [{ required: true, message: "请选择学段", trigger: "change" },],
                eventGrade: [{ required: true, message: "请选择年级段", trigger: "change" },],
                eventBook: [{ required: true, validator: this.checkBookList  },],
                eventTime: [{ required: true, message: "请输入活动时长", trigger: "blur" },],
                eventPrepare: [{ required: true, message: "请输入活动准备", trigger: "blur" },],
                eventFlow: [{ required: true, message: "请输入活动流程", trigger: "blur" },],
            },
            queryParams:{
                bookName:'',
                bookItem:'',
                periodKey:'',
                gradeKey:'',
            },
            bookNum:0,
            allBookList:[],
            bookList:[],
            selVId:''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.handleQueryDict();
        this.handleQueryItem();
        this.queryBookList();
    },
    mounted() {
        if (this.$route.query.eventId) {
            this.eventId = this.$route.query.eventId
            this.queryEventInfo()
        }
    },
    methods: {
        backList(){
            this.$router.push({
                path: "/event",
            });
        },
        submitForm(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    var bookIds = [];
                    this.bookList.forEach(j => {
                        bookIds.push(j.bookId)
                    })
                    this.form.eventBook = bookIds.join(',')
                    if (!this.eventId) {
                        createEvent(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }else {
                        this.form.eventId = this.eventId;
                        updateEvent(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }
                }
            });
        },
        handleQueryItem(){
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.eventGradeList = res.data.data;
            })
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        changePeriodForm() {
            this.form.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.queryBookList()
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.queryBookList()
        },
        queryEventInfo(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
                infoEvent({ eventId: this.eventId }).then(res => {
                    if (res.data.code === 1) {
                        this.form = res.data.data;
                        this.periodList.forEach(j => {
                            if (this.form.periodKey === j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                        // 读物
                        this.bookList = this.form.bookList;
                        if (this.bookList){
                            this.selVId = "";
                            this.bookList.forEach(b => {
                                this.selVId = this.selVId+b.bookId+",";
                            })
                        }
                    }else {
                        this.$message.error("操作失败")
                    }
                })
            });
        },
        /*==========封面信息===========*/
        checkCoverValidator(rule, value, callback) {
            if (this.form.eventCover !== '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.form.eventCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /*==========书目信息===========*/
        checkBookList(rule, value, callback) {
            if (this.bookList.length === 0) {
                callback(new Error('请选择核心读物'))
            } else {
                callback()
            }
        },
        selectBook(){
            this.isShowBook = true;
        },
        addOrCancelBook(item){
            // 添加
            if (!this.selVId.includes(item.bookId)){
                this.selVId = this.selVId+item.bookId+",";
                this.handleListAddBook(item)
            }else {
                this.selVId = this.selVId.replace(item.bookId+",", '');
                this.handleListDelBook(item)
            }
        },
        handleListAddBook(item){
            this.bookList.push(item)
            this.bookNum = this.bookList.length;
        },
        handleListDelBook(item){
            this.bookList = this.bookList.filter(v => v.bookId !== item.bookId);
            this.bookNum = this.bookList.length;
        },
        handleQueryBook(){
            this.queryBookList();
        },
        queryBookList(){
            listBook(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.allBookList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
    },
}
</script>
<style>
.event-avatar-uploader .avatar {
    height: 152px;
    width: 270px;
    display: block;
    object-fit: cover;
}
.event-avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.event-avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.event-avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 152px;
    width: 270px;
    text-align: center;
}
.sel-video-contain{
    width: 800px;
    height: 75vh;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
}
.sel-info-contain{
    width: 800px;
    padding-top: 10px;
    height: 40px;
    display: flex;
}
.info-item1{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-family: sans-serif;

}
.info-item2{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
}
.info-item3{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
    margin-left: 20px;
}
.l-second-container{
    width: 100%;
    height: 30px;
    padding: 0 10px 0 0;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
}
.second-box1{
    width: 20px;
}
.second-box2{
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #377f7f;
}
.second-box3{
    width: calc(100% - 120px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #377f7f;

}
.l-tree-container{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.form-box{
    padding-top: 10px;
}
.r-container{
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.vl-container{
    width: 100%;
    height: calc(100% - 60px)!important;
}
.video-box{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}
.video-item{
    width: 20%;
    height: 235px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
}
.item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -145px;
    padding-top: 30px;
    box-sizing: border-box;
}
.player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.video-cover{
    width: 100%;
    height: 180px;
}
.video-name{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #b1b1b1;
    padding-top: 5px;
}
.video-name-c{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #377f7f;
    padding-top: 5px;
}
.v-list-container{
    width: 800px;
    height: auto;
    padding: 10px 10px 10px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.v-list-item{
    width: 20%;
    height: 215px;
    padding: 0 10px 10px 10px;
    cursor: pointer;
}
.v-t{
    width: 100%;
    height: 30px;
    display: flex;
    padding-top: 5px;
}
.v-t-l{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    color: #121212;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.v-t-r{
    width: 20px;
    height: 22px;
    cursor: pointer;
    margin-top: 3px;
}
</style>
